export default `float de ( vec3 p ) {
  float e, s, t=0.0; 
  vec3 q=p;
  p.z+=7.;
  s=1.;
  for(int j=0;j++<6;)
    s*=e=PI/min(dot(p,p),.8),
    p=abs(p)*e-3.,
    p.y-=round(p.y);
  return e=length(p)/s;
}`